const l = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><g clip-path="url(#a)"><path fill="currentColor" d="M15.93.368A.67.67 0 0 0 15.332 0H.667a.667.667 0 0 0-.534 1.067L6 8.949v5.718c.005.734.6 1.328 1.333 1.333.289 0 .57-.093.8-.267l1.334-1c.335-.252.532-.647.533-1.066V8.949l5.867-7.882a.67.67 0 0 0 .062-.699"/></g><defs><clipPath id="a"><path fill="currentColor" d="M0 0h16v16H0z"/></clipPath></defs></svg>';
export {
  l as default
};
